import axios from 'axios';

const state = () => ({
  section: 1,
  total_sections: 0,
  section_index: 0,
  section_order: [],
  section_names: {},
  has_answers: false,
  uploading_file: false,
});

// getters
const getters = {};

// actions

const actions = {
  async checkIfAnswersPresent({ rootState, commit }) {
    let companyQuestionsSections =
      rootState.carriers.carrierData?.company_question_sections;
    if (companyQuestionsSections?.length > 0) {
      companyQuestionsSections.forEach(function (cqs) {
        cqs?.company_questions.forEach(function (cq) {
          if (
            cq?.question?.current_answer ||
            cq?.question?.most_recent_previous_answer
          ) {
            commit('setHasAnswers', true);
            return;
          }
        });
      });
    }
  },
  async createFileUpload(_, payload) {
    try {
      const res = await axios.post(
        process.env.API_MONITOR + '/api/v1/file_uploads',
        payload
      );
      if ([200, 201].includes(res.status)) {
        console.log('file upload created');
      } else {
        console.log('file upload NOT created');
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deleteFileUpload(_, id) {
    try {
      const res = await axios.delete(
        process.env.API_MONITOR + '/api/v1/file_uploads/' + id
      );
      if ([200, 201, 204].includes(res.status)) {
        console.log('file upload deleted');
      } else {
        console.log('file upload NOT deleted');
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setSection(state, el) {
    state.section = el;
  },
  setSectionIndex(state, el) {
    state.section_index = el;
  },
  setTotalSections(state, el) {
    state.total_sections = el;
  },
  setSectionName(state, el) {
    state.section_names = el;
  },
  setHasAnswers(state, el) {
    state.has_answers = el;
  },
  setSectionOrder(state, el) {
    state.section_order = el;
  },
  setUploadingFile(state, bool) {
    state.uploading_file = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
